import { Button, Input } from "components"
import { useTranslation } from "react-i18next"
import { Box } from "theme-ui"
export const Configuration = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="w-[96%] mx-auto pt-2 transition-all">
   <h1 className="font-semibold text-lg Jakarta-font pb-3 ">{t("configuration")}</h1>
   <Box bg="highlight" color="text-black" className="px-4 py-3 mt-2">
    <h1 className="font-semibold text-lg Jakarta-font ">{t("userSettings")}</h1>
    <div className="mt-4">
     <div className="flex lg:justify-between lg:flex-row flex-col">
      <div className="flex flex-col lg:w-[36%] w-full Jakarta-font">
       <Input
        className="outline-none bg-gray py-3 rounded px-3"
        label={`${t("language")}:`}
        type="text"
        id="Sprache"
        placeholder="Deutsch"
       />
      </div>
      <div className="flex flex-col lg:w-[36%] w-full Jakarta-font">
       <Input
        className="outline-none bg-gray py-3 rounded px-3"
        label="Design:"
        type="text"
        placeholder="Default"
       />
      </div>
      <div className="lg:w-[25%] w-full Jakarta-font ">
       <div className="w-[70%]">
        <h1>{`${t("startOfTheWeek")}:`}</h1>

        <div className="flex w-full  pt-3 Jakarta-font ">
         <div className="w-full flex items-center">
          <Input
           className="customradio"
           type="radio"
           id="first-radiobutton"
           name="commonradiobutton"
          />
          <label className="pl-2" htmlFor="first-radiobutton">
           {t("sunday")}
          </label>
         </div>

         <div className="w-full flex items-center">
          <Input
           className="customradio"
           type="radio"
           id="second-radiobutton"
           name="commonradiobutton"
          />
          <label className="pl-2" htmlFor="second-radiobutton">
           {t("monday")}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>

     <div className="flex lg:flex-row flex-col lg:justify-between mt-4 ">
      <div className="lg:w-[36%] w-full flex items-center">
       <div className="w-full Jakarta-font ">
        <label>{`${t("dateFormat")}:`}</label>
        <div className="bg-gray flex w-full justify-between rounded">
         <Input
          className="bg-gray px-3 py-3 rounded  outline-none lg:w-[70%] w-full text-black "
          type="date"
          placeholder="Enter some text here..."
         />
        </div>
       </div>
      </div>
      <div className="lg:w-[60%] w-full Jakarta-font">
       <h1>{`${t("newMessages")}:`}</h1>
       <div className="w-full flex items-center pt-3">
        <Input className="customradio" type="radio" id=" auf " name="auf" />
        <label className="pl-2" htmlFor=" auf ">
         {`${t("checkForSeriousErrors")}`}
        </label>
       </div>
      </div>
     </div>
    </div>
    <div className=" flex justify-between items-center px-4 py-4 mt-6  Jakarta-font ">
     <p className="text-xs">
      Some other information about these fields to clear the user to fill them*
     </p>

     <div>
      <Button color={"yellow"} size={"xl"}>
       {t("save")}
      </Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
